// ** Next imports

// ** React imports
import { Button } from "react-bootstrap";

// ** File imports
import Layout, { SEOHead } from "../../layouts/default";
import { CONTACT_INFO } from "../../helpers/DATA";
import { FaqTemplate, FaqH, FaqP } from "../../components/support/faqPages";

const Speedtest = () => (
  <Layout>
    <SEOHead title="Speed Test" />

    <FaqTemplate title="Speed Test">
      <FaqP>
        Having speed issues with your connection? First try power cycling your
        modem by unplugging it from power, waiting 10 seconds, then plugging it
        back in. Then allow your modem to power up again before attempting to
        connect. Then run a speed test and check your results.
      </FaqP>

      <FaqH>Step 1</FaqH>

      <FaqP>
        Click the button below to go to our Speed Test Page, which will open in
        a new tab or window. The speed test will find the closest server to your
        location and list the server owner and its approximate location. Click
        the &#8216;GO&#8217; button to begin the speed test.
      </FaqP>

      <a
        href="http://ein.speedtestcustom.com/"
        rel="noreferrer"
        target="_blank"
        style={{
          width: "100%",
        }}
      >
        <Button
          variant="primary"
          style={{
            width: "100%",
          }}
        >
          Go To Speed Test
        </Button>
      </a>

      <FaqH>Step 2</FaqH>

      <FaqP>
        The test will perform a ping check (how long it takes requests to be
        sent and received), jitter (variations in signal strength), download
        speed, and upload speed. There is a COPY button at the end of the test
        which will copy the link to your results to send to EIN. If you&#8217;re
        experiencing issues with your Internet connection these numbers can help
        our technical team diagnose problems. Submit to EIN via email (
        <a href={`mailto:${CONTACT_INFO.email}`}>{CONTACT_INFO.email}</a>) or by
        texting us at {CONTACT_INFO.sms.text}. You can also take a screenshot or
        snap a picture with your phone to send to us!
      </FaqP>
    </FaqTemplate>
  </Layout>
);

export default Speedtest;
